import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {
  merge,
  map,
  flatten,
  valuesIn,
  get,
  set,
  omit
} from 'lodash';
import {getSchema as getJobSchema} from '../../../../../../models/jobRequest';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import FlatButton from '../../../../../../common/components/c_FlatButton';
import { convertToMenuItems } from '../../../../../../redux/helpers/staticData';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import cx from 'classnames';

export default class jobRequestWorksheetSkills extends Component {

  static propTypes = {
    jobRequest: PropTypes.object.isRequired,
    primaryContact: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    handleSave: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  };

  componentWillMount() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.jobRequest) {
      this.setState(merge({}, this.state, {jobRequest: nextProps.jobRequest}));
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      jobRequest: props.jobRequest,
      dirty: false
    }

    this.handleSkillDropdown = ::this.handleSkillDropdown;

    this.menuItems = {
        skills: convertToMenuItems(this.props.staticData.skillOptionTypes, 'id', 'name')
      };

  }

  handleChange(target) {

    return (event, value) => {
       this.setState({dirty: true});
       const skills = this.state.jobRequest.skills;
       
        map(get(skills, `${target.categoryId}`), (skill, index) => {
          if (skill.name === target.name) {
            set(skills, `${target.categoryId}.${index}.skillOption`, value);
          }
        });

        this.setState({jobRequest: this.state.jobRequest})

    }
}

  handleSkillDropdown(skill, menuItems, index) {

    return {
      'data-id': `skillOption${index}`, 
      value: skill.skillOption,
      onChange: this.handleChange(skill),
      menuItems: menuItems,
      canAutoPosition: true,
      disabled: this.props.disabled,
    }
  }

  handleSave = (evt) => {

    if(this.state.dirty === false) {
      return;
    }
    
    this
      .props
      .handleSave({
        company: {
          id: this.props.primaryContact.company.id,
        },
        jobrequest: omit(this.state.jobRequest, ['primaryContact'])
      }).then(() => {
        this.setState({dirty: false });
      })

  }

  render() {

    const {props, state} = this;
    const skills = flatten(valuesIn(this.props.jobRequest.skills));

    return (
      <div className='job-request-worksheet-skills'>
        <div className='summary-skills-table'>
          <Table selectable={false} multiSelectable={false}>
            <TableHeader displaySelectAll={false}  adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn style={{ 'paddingRight': '0', 'paddingLeft': '0'}} className='name'>
                  <h2>Skills</h2>
                </TableHeaderColumn>
                <TableHeaderColumn style={{width: '120px', 'paddingRight': '0', 'paddingLeft': '0'}} className='option'>
                   <h2>Importance</h2>
                </TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
            {
              skills.map( (skill, index) => skill.name !== 'None' &&
                 <TableRow key={`${skill.categoryId}-${skill.name}`}>
                    <TableRowColumn style={{ 'paddingRight': '0', 'paddingLeft': '0'}}  data-id={`SkillName${index}`} className='name'>
                    {skill.name}
                    </TableRowColumn>
                    <TableRowColumn style={{width: '143px', 'paddingRight': '0', 'paddingLeft': '0'}} className='option'>
                        <DropDownMenu style={{width: '100%'}} {...this.handleSkillDropdown(skill, this.menuItems.skills, index)} />
                    </TableRowColumn>
                </TableRow>
              )
            }
          </TableBody>
        </Table>
      </div>
       {this.props.disabled ? null : <div className='grid'>
          <div className='row'>
            <div className='col'>
              <FlatButton
                className={cx('button-save', {disabled: !this.state.dirty})}
                onClick={this.handleSave}
                data-id='save'
                label='save'/>
            </div>
          </div>
        </div> }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Worksheet/Profile/Skills/index.js